module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.2100602c.woff";